import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import { Image, Flex, Box } from '@chakra-ui/react';
import { redirectToLandingPage } from '../../global/helpers/global-helpers';

import logo from '../../global/styles/images/launchdeck_logo.svg';
import LaunchdeckButton from '../../global/components/helper-components/components/LaunchdeckButton';

function JoinRequestInProgressDisplay({ teamLogos, isMobileView }) {
	const renderLogo = () => {
		const { displayedHostLogo, displayedAudienceLogo } = teamLogos || {}
	
		if (displayedHostLogo) {
			return (
				<Flex w='100%' justify='center' align='center' mb='2em' >
					<Image src={displayedHostLogo} alt="Host Logo" maxHeight='3em' />

					{displayedAudienceLogo &&
						<Flex align='center' >
							<Flex mx='1em'>&</Flex>
							<Image src={displayedAudienceLogo} alt="Guest Logo" maxHeight='3em' />

						</Flex>}
				</Flex>
			)
		} else {
			return (
				<Flex w='100%' justify='center' pt='1em'>
					<Image src={logo} alt="Launchdeck Logo" width='50%' minWidth='15em' maxWidth='20em' mb='2em' onClick={() => redirectToLandingPage()} />
				</Flex>
			)
		}
	}

	return (
		<Box w={isMobileView && '90%'} margin='auto'>
			<Box alignItems='center' bg='white' rounded='0.25em' p='1em'>
				{renderLogo()}

				<Box direction='column' maxWidth='37.5em' m='auto'>
					<Flex direction='column' alignItems='center' bg='white' rounded='0.25em' >
						<Box w='100%' py='0.8em' >
							<Box w='100%' fontSize='1.2em' lineHeight='1.875em' fontWeight='500' textAlign='center'>Your join request is in review</Box>
						</Box>


						<Box w='100%' p='1.5em'>
							<Box textAlign='center' fontSize='0.875em' whiteSpace='pre-wrap'>
								{`Room Administrators are still reviewing it. \nPlease check in again later.`}
							</Box>
							<Flex mt='3em' alighItems='center' justify='center'>
								<LaunchdeckButton bg='brand.500' color='white' onClick={() => redirectToLandingPage()} label='Return' />
							</Flex>
						</Box>

					</Flex>
				</Box>
			</Box>
		</Box>
	);
}

function mapStateToProps(state) {
	return {
		isMobileView: state.mobileViewMode.isMobileView
	};
}


export default withRouter(connect(mapStateToProps, null)(JoinRequestInProgressDisplay));
